import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './Benefits.styles'

const getBenefitColumnSize = (value) => {
  if (value === 2) {
    return 6
  }
  if (value === 1) {
    return 12
  }
  return 4
}

const Benefits = ({ services }) => {
  const service = services[0]
  const givenBenefits = service.bodyCopy
  const benefitsList = givenBenefits.map((givenBenefit, benefitIndex) => {
    return (
      <Styled.SuccessMargin
        gutterValue={1}
        gutterSize='15px'
        numberOfColumns={12}
        sm={getBenefitColumnSize(givenBenefits.length)}
        key={`benefit-${benefitIndex}`}
        data-test={`m023-benefit-container-${benefitIndex}`}
      >
        <Styled.TextContainer gutterValue={0} row='sm'>
          {service.icon === 'SuccessIcon' && (
            <Styled.BenefitsSvg data-test='m023-benefits-icon' iconColor={service.iconColor} />
          )}
          <Styled.BenefitsText data-test='m023-benefits-bodyCopy-container'>
            <strong data-test='m023-benefits-bodyCopy'>{givenBenefit}</strong>
          </Styled.BenefitsText>
        </Styled.TextContainer>
      </Styled.SuccessMargin>
    )
  })

  return (
    <Styled.WrapperBenefit data-test='m023-benefits-container'>
      <Styled.BenefitsWrapper data-test='m023-benefits-wrapper'>{benefitsList}</Styled.BenefitsWrapper>
    </Styled.WrapperBenefit>
  )
}

Benefits.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['benefit', 'proposition']),
      heading: PropTypes.string,
      cardApr: PropTypes.string,
      aprCopy: PropTypes.string,
      tsAndCs: PropTypes.string,
      ctaStyle: PropTypes.string,
      ctaDestination: PropTypes.oneOf(['Credit', 'Click & collect', 'Fasttrack - delivery']),
      mainImage: PropTypes.shape({
        source: PropTypes.string.isRequired,
        altText: PropTypes.string.isRequired
      })
    })
  ).isRequired
}

export { Benefits }
